// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1A5Re","image":"Header_image__2-QDD","name":"Header_name__2wSuc","info":"Header_info__33jlL","infoRow":"Header_infoRow__MkAZx"};